import React from 'react'

const CreateProject2 = ({ onClick }) => {
  return (
    <div
      className="project-item project-item--admin project-item-center"
      onClick={onClick}
    >
      <div className="icon-container">➕</div>
      <h2 className="create-title">Crear proyecto</h2>
      <p className="card-description">
        Haz clic para agregar un nuevo proyecto a esta sección.
      </p>
    </div>
  )
}

export default CreateProject2
